// Simple accordion
document.addEventListener('DOMContentLoaded', function () {
  let accordions = document.querySelectorAll('.accordion-toggler');
  if (accordions) {
    accordions.forEach(function (accordion) {
      accordion.addEventListener('click', function (event) {
        accordion.classList.toggle('active');
      });
    });
  }
});
